import { CommonModule, Location } from '@angular/common';
import { booleanAttribute, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Icon } from '../../icon/icon.component';

@Component({
  selector: 'app-page-modal-container',
  standalone: true,
  imports: [CommonModule, Icon],
  template: `
    <main
      [class.xl:hidden]="!desktop()"
      [class.slide]="slideEnabled()"
      [ngClass]="mainClass() ? mainClass() : 'bg-white'"
      class=" overflow-x-hidden absolute z-[999] inset-0 w-full min-h-screen h-full"
    >
      <section class="fixed top-0 z-10 flex justify-between w-full p-4 bg-white ">
        @if(title()){
        <div></div>
        <p class="text-center text-neutral-800 font-semibold">{{ title() }}</p>
        }
        <app-icon
          (click)="goBack($event)"
          [name]="close() ? 'material-symbols:close-rounded' : 'material-symbols:arrow-back-ios'"
          class="text-gray-500 cursor-pointer place-self-end"
          size="sm"
        />

        <ng-content select="[icons]" />
      </section>

      <section class="z-50 h-full pb-20 pt-12">
        <ng-content />
      </section>
      <section class="fixed bottom-0 w-full bg-white ">
        <ng-content select="[footer]" />
      </section>
    </main>
  `,
  styleUrl: './page-modal-container.component.scss',
})
export class PageModalContainer {
  location = inject(Location);
  router = inject(Router);

  desktop = input(false, { transform: booleanAttribute });
  close = input(true, { transform: booleanAttribute });
  slideEnabled = input(true, { transform: booleanAttribute });
  goBackUrl = input('');
  mainClass = input('');
  title = input('');

  goBack(ev?: Event) {
    ev?.stopPropagation();
    ev?.preventDefault();

    if (this.goBackUrl()) {
      this.router.navigate([this.goBackUrl()], { replaceUrl: true });
      return;
    }
    this.location.back();
  }
}
